export function encodeSearchQuery(str: string) {
  return str
    .replace(/\//g, '-')
    .replace(/-/g, '~')
    .replace(/,\s{1}/g, '--')
    .replace(/ /g, '-');
}
